import { IListItem, ListItemTypeEnum } from "@/types/list";

export const getIsCurrentLang = (item: IListItem, localeValue: string) => {
  return item.type === ListItemTypeEnum.Lang && item.lang === localeValue;
};
